import { BulletPointsConfigModel, ProductConfigProps } from "models/WebShop";
import { useState } from "react";

const BulletPointsConfig = ({ config, handleOnChange, handleFormValidation }: ProductConfigProps<BulletPointsConfigModel>) => {

    const initialConfig = config?.[0].bulletPoints;
    
    const [bulletPoints, setBulletPoints] = useState<string[]>(
            initialConfig ?? []
        );

        const handleDragStart = (e: React.DragEvent<HTMLLIElement>, index: number) => {
                e.dataTransfer.setData('dragIndex', index.toString());
            };
        
            const handleDrop = (e: React.DragEvent<HTMLLIElement>, dropIndex: number) => {
                const dragIndex = parseInt(e.dataTransfer.getData('dragIndex'), 10);
                const newItems = [...bulletPoints];
                const [draggedItem] = newItems.splice(dragIndex, 1);
                newItems.splice(dropIndex, 0, draggedItem);
                setBulletPoints(newItems);
        
                if (newItems.every(item => item === '')){
                    handleFormValidation(false)
                }
                else{
                    handleFormValidation(true);
                }
                addAction(newItems);
            };
        
            const handleInputChange = (index: number, value: string) => {
                const newItems = [...bulletPoints];
                newItems[index] = value;
        
                if (newItems.every(item => item === '')){
                    handleFormValidation(false)
                }
                else{
                    handleFormValidation(true);
                }
        
                setBulletPoints(newItems);
                addAction(newItems);
            };
        
            const addAction = (value:string[]) => {
        
                const updatedProduct: BulletPointsConfigModel = {
                    bulletPoints: value,
                    crmProductId: config[0].crmProductId,
                    crmPublishLineId: config[0].crmPublishLineId
                };
                handleOnChange([updatedProduct]);
            };


        return <>
            <p className="text-muted d-none d-lg-inline">
                Maks 30 tegn i hvert listeelement. Dra og slipp for å endre rekkefølge. Endringer på kjøpte produkter vil bli behandlet fortløpende før det vises på nett.
            </p>

            <div className="mb-4">
                <ul className="cc-draggable-list list-unstyled">

                    {bulletPoints.map((text, index) => (
                        <li
                            key={index}
                            draggable
                            onDragStart={(e) => handleDragStart(e, index)}
                            onDragOver={(e) => e.preventDefault()}
                            onDrop={(e) => handleDrop(e, index)}
                            className="d-flex align-items-center gap-2 mb-2"
                        >
                            <span className="cc-drag-handle d-none d-lg-inline">⠿</span>
                            <div className="cc-draggable-list-disc">
                                <input
                                    type="text"
                                    className="form-control border-primary border-opacity-25"
                                    maxLength={30}
                                    value={text}
                                    onChange={(e) => handleInputChange(index, e.target.value)}
                                    aria-label={`Punktliste tekst ${index + 1}`}
                                />
                            </div>
                        </li>
                    ))}

                </ul>
            </div>
        </>
}

export default BulletPointsConfig;